import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import { FormField } from '../../../components/form/FormField';
import { applicationActions } from '../../../actions/applicationActions';
import { Loader } from '../../../components/Loader';

let ApplicationFilterForm = props => {
  const { handleSubmit, submitting, handleModalClose } = props;

  return (
    <form onSubmit={handleSubmit}>
      <Field
        name="application_id"
        type="text"
        label="Номер заявления"
        className=""
        component={FormField}
      />
      <Field name="number" type="text" label="ГРЗ ТС" className="" component={FormField} />
      <Field name="form_id" type="text" label="Номер бланка" className="" component={FormField} />
      <Button
        variant="contained"
        color="primary"
        className="btn-add no-margin"
        type="submit"
        disabled={submitting}
      >
        {submitting && <Loader />} Применить
      </Button>
      &nbsp;
      <Button variant="outlined" component="span" className="info-btn" onClick={handleModalClose}>
        Отменить
      </Button>
    </form>
  );
};

ApplicationFilterForm = reduxForm({
  form: 'application-control-filter-form',
  enableReinitialize: false,
  destroyOnUnmount: false
})(ApplicationFilterForm);

const mapStateToProps = state => {
  const { authentication } = state;
  const { user } = authentication;
  return {
    initialValues: {
      department_id: user.department_id
    }
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const handleModalClose = () => {
    dispatch(applicationActions.closeFilterModal());
  };
  return {
    handleModalClose,
    dispatch
  };
};

ApplicationFilterForm = connect(
  mapStateToProps,
  mapDispatchToProps
)(ApplicationFilterForm);
export default ApplicationFilterForm;
